import Chevron from '../assets/chevron.svg'
import moment from 'moment'
import 'moment/locale/ro'
import {Row} from "./Row";
import {useState} from "react";

export const PrizesDisplay = (props) => {
    const [extended, setExtended] = useState(false)
    const race = props.data
    return (
        <>
            {props.showHeader && <div className="card-row card-data-dropdown-item card-table-header" onClick={() => setExtended(!extended)}>
                <div className="card-data card-data-title">{moment(race.date).locale('ro').format('D MMMM YYYY')}</div>
                <div className="card-data card-data-title">
                    <div className="card-data-prize"><span>{race.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }</span> <span>{props.spins ? 'Runde acordate' : 'Lei Acordați'}</span></div>
                </div>
                <div className="card-data dropdown card-data-title"><img className="chevron" src={Chevron} alt="chevron" style={extended ? {transform: 'rotate(180deg)'} : {}}/>
                </div>
            </div>}
            <div className={"card-row-dropdown-container " + (props.long ? '' : 'height-dropdown-container ') + (!props.showHeader ? 'toggle' : (extended ? 'toggle' : ''))}>
                {
                    race.items.map((player, index) => <Row key={index} type={'Premii instant'} data={player}/>)
                }
            </div>
        </>
    )
}